export default __webpack_public_path__ + "static/media/apdated-logo.1eaa61e6.svg";